(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .controller('GroupPracticeTableController', GroupPracticeTableControllerFn);

    /* controller for protocol categories table */
    GroupPracticeTableControllerFn.$inject = ['ItemTableService', '$state','$uibModal','GroupPracticeService','HelperService'];

    function GroupPracticeTableControllerFn(ItemTableService, $state,$uibModal,GroupPracticeService,HelperService) {
        var vm = this;
        // the service -> here the ItemTableService
        vm.overview = null;

        // start
        activate();

        // add new row to table
        vm.add = function () {
            var newGroupPractice = {
                Id: 0,
                name: '',
                description: '',
              };
              showEditModal(newGroupPractice);
        };

        vm.edit = function(grouppractice) {
            showEditModal(grouppractice);
        }

        vm.delete = function(grouppractice) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                return GroupPracticeService.deleteGroupPractice(grouppractice)
                                    .then(function() {
                                       loadGroupPractices();
                                    });
            });
        }
          
        //show detail
        function showEditModal(grouppractice) {           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/administration/modules/grouppractice/templates/grouppractice-detail.template.html',
                controller: 'GroupPracticeDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    grouppractice: ['GroupPracticeService', function (GroupPracticeService) {
                        
                        if (grouppractice.id > 0) {
                        return GroupPracticeService
                                    .getGroupPractice(grouppractice.id)
                                    .then(function (grouppractice) {
                            return grouppractice;
                        });}
                        return grouppractice;
                    }]
                }
            });
            modalInstance.result.then(function (item) {
                return loadGroupPractices();
            });
        }

        function orderBy(a, b) {
            return a.id - b.id; // ascending
        }

        function loadGroupPractices() {
            GroupPracticeService.getGroupPractices()
                .then(function(grouppractices) {
                    vm.overview.init(grouppractices,ItemTableService.languages, ItemTableService.prototype, ItemTableService.requiredFields, true);
                    vm.overview.data.sortFn = orderBy;
                    vm.overview.sort();
                });
        }

        /* activation work */
        function activate() {            
            //service
            vm.overview = ItemTableService;
            loadGroupPractices();
        } // activate
    }
})();
